<div class="link-container">
  <span>{{ statusText }}</span>
</div>
